import { Form, Row, Col } from "react-bootstrap";
import { TextField, InputLabel } from "@mui/material";
import Button from "@mui/material/Button";
import { marginBottom } from "../App";

export default function TaskChatFormPzitb({
  userData,
  author,
  title,
  content,
  reporter,
  error,
  handleAuthorChange,
  handleTitleChange,
  handleContentChange,
  handleSubmit,
}) {
  return (
    <div
      style={{
        backgroundColor: "#f5f5e8ff",
        border: "1px solid #d6cea5ff",
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "20px",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)", // lekki cień
      }}
    >
      <Row style={{ marginBottom }}>
        <Col>
          <InputLabel id="content-label">Osoba wysyłająca:</InputLabel>
          <Form.Group controlId="formTitle">
            <TextField
              type="text"
              name="author"
              fullWidth
              variant="outlined"
              value={userData.fullName}
              onChange={handleAuthorChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Form.Group>
        </Col>
        <Col>
          <InputLabel id="content-label">
            Zleceniodawca - mail: <b>{reporter}</b>
          </InputLabel>
          <Form.Group controlId="formTitle">
            <TextField
              type="text"
              name="title"
              label="Temat korespondencji do Zleceniodawcy"
              fullWidth
              variant="outlined"
              value={title}
              onChange={handleTitleChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row style={{ marginBottom }}>
        <Col>
          <Form.Group controlId="formContent">
            <TextField
              type="text"
              name="content"
              label="Treść korespondencji"
              fullWidth
              multiline
              minRows={3}
              variant="outlined"
              value={content}
              onChange={handleContentChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Form.Group>

          <div style={{ marginTop: "15px" }}>
            <Button
              type="submit"
              variant="contained"
              color="warning"
              onClick={handleSubmit}
            >
              Wyślij korespondencję do Zleceniodawcy
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}
